module.exports = __webpack_public_path__ + "img/imagen4.d87bdf43.png";